export var valuesGameMode = ["Single", "Versus"];
/*

*/ 
//# sourceMappingURL=GameMode.js.map